/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './NamedResourceTag';
/**
 * Check if a given object implements the PlayerResponse interface.
 */
export function instanceOfPlayerResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "creationDate" in value;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function PlayerResponseFromJSON(json) {
    return PlayerResponseFromJSONTyped(json, false);
}
export function PlayerResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'creationDate': json['creationDate'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'resolution': !exists(json, 'resolution') ? undefined : json['resolution'],
        'rotation': !exists(json, 'rotation') ? undefined : json['rotation'],
        'orientation': !exists(json, 'orientation') ? undefined : json['orientation'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'fingerPrintId': !exists(json, 'fingerPrintId') ? undefined : json['fingerPrintId'],
        'confirmationDate': !exists(json, 'confirmationDate') ? undefined : json['confirmationDate'],
        'confirmedBy': !exists(json, 'confirmedBy') ? undefined : json['confirmedBy'],
        'publicKey': !exists(json, 'publicKey') ? undefined : json['publicKey'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'active': json['active'],
        'screenPositions': !exists(json, 'screenPositions') ? undefined : json['screenPositions'],
        'impressions': !exists(json, 'impressions') ? undefined : json['impressions'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'provider': !exists(json, 'provider') ? undefined : json['provider']
    };
}
export function PlayerResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'id': value.id,
        'creationDate': value.creationDate,
        'format': value.format,
        'resolution': value.resolution,
        'rotation': value.rotation,
        'orientation': value.orientation,
        'metaData': MetaDataToJSON(value.metaData),
        'fingerPrintId': value.fingerPrintId,
        'confirmationDate': value.confirmationDate,
        'confirmedBy': value.confirmedBy,
        'publicKey': value.publicKey,
        'locationId': value.locationId,
        'networkId': value.networkId,
        'active': value.active,
        'screenPositions': value.screenPositions,
        'impressions': value.impressions,
        'referenceId': value.referenceId,
        'provider': value.provider
    };
}
